<template>
      <div class="warpImgEl">
        <el-upload
              :action="httpUrl"
              :headers="headers"
              :before-upload="UploadLimitBtn"                 
              :on-success="uploadImg" 
              >
              <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </div>
</template>
<script>
  import {url,api} from '@/utils/config'
  export default {
    data:()=>({
        httpUrl:"",   //请求的url
        headers:{},   //请求头部
    }),

   created(){
     
   },
    mounted(){
      this.headers={'Authorization':localStorage.getItem("YunWeiTikenBRJ")}
      this.httpUrl = url.UPLOADAPK
    },
    methods:{ 

      //上传文件前的出发事件
      UploadLimitBtn(files){
         console.log("上传前的",files.type)
         // const isJPG =  files.type === 'image/jpeg' ;
         // if (!isJPG) {
         //    this.$message.error('上传图片只能是'++'格式!');
         // }
         // return isJPG 
      }, 

      //上传图片后获取数据
      uploadImg(response, files, fileList){
         this.$emit('getUpload',response.data)
      }
    }
  }
</script>
<style lang="scss" scoped>
   .warpImgEl{
     ::v-deep .el-upload-list--picture-card .el-upload-list__item,::v-deep .el-upload--picture-card{
        width:80px;
        height:80px;
        display: block;
        margin: 0 8px 0 0;
     }
     ::v-deep .el-upload--picture-card i{
        position: relative;
        bottom: 28px;   
     }
   }
   .warpImgEl>div{
      display: flex;
   }
   .mark{
      color: red;
      padding-top:0px;
      line-height:20px;
      font-size: 12px;
   }
</style>